import { validateEmail } from 'utils/auth'
import { parsePhoneNumber, isValidPhoneNumber } from 'utils/phoneNumber/phoneNumber'

// signup-service's GB rule (class-validator isPostalCode 'GB'), so what passes here isn't a 400 on /signup
const UK_POSTCODE_PATTERN = /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i

export const emailValidator = (value) =>
  !value || !validateEmail(value) ? 'Please provide a valid email address' : undefined
export const phoneValidator = (value) => {
  const phone = value && parsePhoneNumber(value)
  const isValid = value && isValidPhoneNumber(value, 'GB')

  return !value || (phone && phone.country !== 'GB') || !isValid
    ? 'Enter a UK phone number'
    : undefined
}

export const ukPostcodeValidator = (value) =>
  UK_POSTCODE_PATTERN.test(value) ? undefined : 'Please enter a valid UK postcode'
